import { Link } from "react-router-dom";
import FastSendLogo from "../components/FastSendLogo";

const FEATURES = [
  { icon: "⚡", title: "Fast Matching", desc: "The nearest available dispatcher gets offered your delivery in seconds." },
  { icon: "🔒", title: "Verified Delivery", desc: "A one-time PIN confirms every drop-off — no delivery marked done without it." },
  { icon: "🗺️", title: "Live Tracking", desc: "Watch your dispatcher move on the map in real time, from pickup to your door." },
  { icon: "🏢", title: "For Businesses Too", desc: "Agents, Fleet Owners, B2B, and Corporate accounts — built for scale." }
];

const VEHICLES = [
  { icon: "🚲", label: "Bicycle" },
  { icon: "🏍️", label: "Motorcycle" },
  { icon: "🚐", label: "Van" },
  { icon: "🚚", label: "Truck" }
];

export default function Landing() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-primary)", color: "var(--text-primary)" }}>
      {/* NAV */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", maxWidth: "1100px", margin: "0 auto" }}>
        <FastSendLogo variant="horizontal" size="small" />
        <div style={{ display: "flex", gap: "10px" }}>
          <Link to="/login"><button className="secondary" style={{ width: "auto", padding: "8px 18px", marginTop: 0 }}>Log In</button></Link>
        </div>
      </div>

      {/* HERO */}
      <div style={{ maxWidth: "720px", margin: "0 auto", textAlign: "center", padding: "40px 24px 60px" }}>
        <h1 style={{ fontSize: "clamp(28px, 6vw, 44px)", fontWeight: 800, lineHeight: 1.15, margin: 0 }}>
          Send anything, anywhere in the city —{" "}
          <span style={{ background: "var(--accent-gradient)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>
            fast.
          </span>
        </h1>
        <p style={{ color: "var(--text-secondary)", fontSize: "17px", marginTop: "16px" }}>
          From a document to a truckload — FastSend matches you with the nearest available dispatcher,
          on a bicycle, motorcycle, van, or truck.
        </p>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap", marginTop: "28px" }}>
          <Link to="/register/user">
            <button style={{ width: "auto", padding: "12px 28px" }}>📦 Send a Package</button>
          </Link>
          <Link to="/register/rider">
            <button className="secondary" style={{ width: "auto", padding: "12px 28px" }}>🛵 Become a Dispatcher</button>
          </Link>
        </div>

        {/* Vehicle strip */}
        <div style={{ display: "flex", justifyContent: "center", gap: "24px", flexWrap: "wrap", marginTop: "36px" }}>
          {VEHICLES.map(v => (
            <div key={v.label} style={{ textAlign: "center" }}>
              <div style={{ fontSize: "28px" }}>{v.icon}</div>
              <div style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "4px" }}>{v.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "0 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
          {FEATURES.map(f => (
            <div key={f.title} className="delivery-card" style={{ margin: 0 }}>
              <div style={{ fontSize: "26px" }}>{f.icon}</div>
              <div style={{ fontWeight: 700, marginTop: "8px" }}>{f.title}</div>
              <p style={{ fontSize: "13px", color: "var(--text-secondary)", marginTop: "4px" }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* BUSINESS CTA */}
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "0 24px 60px" }}>
        <div className="delivery-card" style={{ margin: 0, textAlign: "center" }}>
          <h3 style={{ marginTop: 0 }}>🏢 Running a business?</h3>
          <p className="hint" style={{ marginBottom: "16px" }}>
            Agent, Fleet Owner, B2B, and Corporate accounts — with API access, consolidated invoicing, and fleet rollups.
          </p>
          <Link to="/login">
            <button className="secondary" style={{ width: "auto", padding: "10px 24px" }}>Explore Business Accounts</button>
          </Link>
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "20px 24px", color: "var(--text-muted)", fontSize: "13px" }}>
        © {new Date().getFullYear()} FastSend. Built for Nigeria's delivery hustle.
      </div>
    </div>
  );
}
